import { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import api from '../../../../../src/connection/api';
import Alert from '../../../../alert/alert_msg';

export default function UserEdit() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    password: '',
    password_confirmation: '',
    role: '',
    bnka: '',
    circle_id: '',
    isActive: '', 
  });

  const [bazna, setBazna] = useState([]);
  const [bnka, setBnka] = useState([]);
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  const GetData = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await api.get(`/admin/getUser/${id}`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      // Check the actual structure of your API response
      const userData = response.data.user || response.data.data || response.data;
      
      setFormData({
        name: userData.name || '',
        email: userData.email || '',
        phone: userData.phone || '',
        role: userData.role || '',
        bnka: userData.bnka || userData.base_id || '',
        circle_id: userData.circle_id || '',
        isActive: userData.isActive?.toString() || userData.status || '' 
      });

    } catch (error) {
      console.error("Error fetching user data:", error);
      Alert('هەڵە لە هێنانی زانیارییەکان', 'error');
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    
     GetData();
    getCircle();
    getBnka();
  }, [id]);

  const getCircle = async () => {
    try {
      const token = localStorage.getItem("token");
      const response = await api.get("/circle/index", {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json"
        }
      });
      setBazna(response.data.AllData || []);
    } catch (error) {
      console.error("Error fetching circles:", error);
    }
  };

  const getBnka = async () => {
    try {
      const token = localStorage.getItem("token");
      const response = await api.get("/base/index", {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json"
        }
      });
      setBnka(response.data.data || []);
    } catch (error) {
      console.error("Error fetching bases:", error);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => {
      const newState = { ...prev, [name]: value };
      // Clear error for this field when user starts typing
      if (errors[name]) {
        setErrors(prevErrors => ({ ...prevErrors, [name]: [] }));
      }
      return newState;
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    const token = localStorage.getItem("token");
     
    try {
      // Use PUT or PATCH for updating user instead of POST /admin/register
      const response = await api.post(`/admin/updateUser/${id}`, formData, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
    //   console.log(response);
      if (response.data.success === true) {
        Alert('زانیارییەکان بە سەرکەوتوویی نوێکرایەوە', 'success');
        navigate('/admin/supervisors');
      }
    } catch (error) {
      if (error.response?.status === 422) {
        // Laravel validation errors
        setErrors(error.response.data.errors || {});
        Alert('هەڵە لە زانیارییەکاندا', 'error');
      } else {
        setErrors({ general: [error.response?.data?.message || 'هەڵەیەک ڕوویدا'] });
        Alert(error.response?.data?.message || 'هەڵەیەک ڕوویدا', 'error');
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleCancel = () => {
    navigate('/admin/supervisors');
  };

  // Helper function to render error messages for a specific field
  const renderFieldErrors = (fieldName) => {
    if (errors[fieldName] && errors[fieldName].length > 0) {
      return (
        <div className="field-errors">
          {errors[fieldName].map((error, index) => (
            <div key={index} className="error-message">
              {error}
            </div>
          ))}
        </div>
      );
    }
    return null;
  };

  if (isLoading) {
    return (
      <div className="page active">
        <div className="loading">لە هێنانی زانیارییەکان...</div>
      </div>
    );
  }

  return (
    <div className="page active">
      <div className="page-header">
        <h1>نوێکردنەوەی بەکارهێنەر</h1>
      </div>

      <div className="form-page">
        {/* General errors */}
        {errors.general && (
          <div className="general-errors">
            {errors.general.map((error, index) => (
              <div key={index} className="error-message">
                {error}
              </div>
            ))}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="name">ناوی بەکارهێنەر *</label>
            <input 
              type="text" 
              id="name" 
              name="name" 
              required
              value={formData.name}
              onChange={handleChange}
              className={errors.name ? 'has-error' : ''}
            />
            {renderFieldErrors('name')}
          </div>
          
          <div className="form-group">
            <label htmlFor="phone"> ژمارە مۆبایل *</label>
            <input 
              type="text" 
              id="phone" 
              name="phone" 
              required
              value={formData.phone}
              onChange={handleChange}
              className={errors.phone ? 'has-error' : ''}
            />
            {renderFieldErrors('phone')}
          </div>
          
          <div className="form-group">
            <label htmlFor="email">ئیمەیڵ *</label>
            <input 
              type="email" 
              id="email" 
              name="email" 
              required
              value={formData.email}
              onChange={handleChange}
              className={errors.email ? 'has-error' : ''}
            />
            {renderFieldErrors('email')}
          </div>

         

          

          <div className="form-group">
            <label htmlFor="role">ڕێگەپێدان *</label>
            <select 
              id="role" 
              name="role" 
              required
              value={formData.role}
              onChange={handleChange}
              className={errors.role ? 'has-error' : ''}
            >
              <option value="">ڕێگەپێدان هەڵبژێرە</option>
              {localStorage.getItem('role')==='superadmin' && (
             <div>
               <option value="superadmin">Super Admin</option> 
             </div>

          )}
              <option value="admin">ئەدمین</option>  
              <option value="user">چاودێر</option>
            </select>
            {renderFieldErrors('role')}
          </div>

          <div className="form-group">
            <label htmlFor="circle_id">بازنە *</label>
            <select 
              id="circle_id" 
              name="circle_id" 
              required
              value={formData.circle_id}
              onChange={handleChange}
              className={errors.circle_id ? 'has-error' : ''}
            >
              <option value="">بازنە هەڵبژێرە</option>

              {localStorage.getItem('role')==='admin' && bazna  && ( 
           <option key={bazna.id} value={bazna.id}>
           {bazna.circle_name}
         </option>
      
               )} 

               {localStorage.getItem('role')==='superadmin' && bazna  && Array.isArray(bazna) && bazna.length > 1 && bazna.map((item) => (
                <option key={item.id} value={item.id}>
                  {item.circle_name}
                </option>
              )) 
           }


              {/* {bazna.map((item) => (
                <option key={item.id} value={item.id}>
                  {item.circle_name}
                </option>
              ))} */}
            </select>
            {renderFieldErrors('circle_id')}
          </div>

          <div className="form-group">
            <label htmlFor="bnka">بنکە *</label>
            <select 
              id="bnka" 
              name="bnka" 
              required
              value={formData.bnka}
              onChange={handleChange}
              className={errors.bnka ? 'has-error' : ''}
            >
              <option value="">هەڵبژاردنی بنکە</option>
              {bnka.map((item) => (
                <option key={item.id} value={item.id}>
                  {item.base_name}
                </option>
              ))}
            </select>
            {renderFieldErrors('bnka')}
          </div>

          <div className="form-group">
            <label htmlFor="isActive">چالاک/ناچالاک *</label>
            <select 
              id="isActive" 
              name="isActive" 
              required
              value={formData.isActive}
              onChange={handleChange}
              className={errors.isActive ? 'has-error' : ''}
            >
              <option value="">هەڵبژاردن</option>
              <option value="1">چالاک</option>
              <option value="0">ناچالاک</option>
            </select>
            {renderFieldErrors('isActive')}
          </div>

          <div className="form-actions">
            <button 
              type="submit" 
              className="btn-primary"
              disabled={isSubmitting}
            >
              <i className="fas fa-save"></i>
              {isSubmitting ? 'لە پڕۆسێندا...' : 'نوێکردنەوە'}
            </button>
            <button type="button" className="btn-secondary" onClick={handleCancel}>
              <i className="fas fa-arrow-right"></i>
              گەڕانەوە
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}